export default "__VITE_ASSET__vy_J5_kK__"